import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

const MarkdownReader = (props) => (
  <ReactMarkdown source={props.input} />
)

MarkdownReader.propTypes = {
  input: PropTypes.string.isRequired
};

export default MarkdownReader;



// WEBPACK FOOTER //
// ./src/components/interactive/markdown/MarkdownReader.js